export default __webpack_public_path__ + "static/media/logo.baa08d63.jpg";